import React from "react";
import { useTranslation } from "react-i18next";

import Button from "layout/atoms/Button";
import ContentBox from "layout/atoms/ContentBox";
import Header from "layout/atoms/Header";
import MainContainer from "layout/atoms/MainContainer";

function NoActiveCompany() {
  const { t } = useTranslation();

  return (
    <MainContainer>
      <ContentBox>
        <Header size="h3" margin="m">
          {t("noActiveCompany.header")}
        </Header>
        <p style={{ marginBottom: "20px" }}>
          {t("noActiveCompany.description")}
        </p>
        <Button size="lg" color="primary" to="/logout">
          {t("menuToolbar.logOut")}
        </Button>
      </ContentBox>
    </MainContainer>
  );
}

export default NoActiveCompany;
